import React, { Component } from "react";

import { DnaWorkflowContextProvider } from "./context/context";
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";

class DnaWorkflowsPage extends Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <DnaWorkflowContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </DnaWorkflowContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default DnaWorkflowsPage;
